module.exports = __webpack_public_path__ + "static/figurine_of_wondrous_power_marble_elephant-783ab6cd9047a8878729444ab839669e.jpg";